exports = module.exports = require("../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".inbox-sidebar-header[data-v-df2ce6a0]{padding:1em .75em 0;text-transform:uppercase;font-size:.9em;font-weight:600;width:100%;color:#aaa}", ""]);

// exports



//////////////////
// WEBPACK FOOTER
// ./node_modules/css-loader?minimize!./node_modules/vue-loader/lib/style-compiler?{"vue":true,"id":"data-v-df2ce6a0","scoped":true,"hasInlineConfig":false}!./node_modules/vue-loader/lib/selector.js?type=styles&index=0!./src/components/received-files-view/received-files-sidebar-section.vue
// module id = 96
// module chunks = 0